import {
  returnStringOrNull,
  returnNumberOrNull,
  returnObjectOrNull,
  returnBooleanOrNull,
} from './type-check'
import { createVariantImageSlideElement } from '../templates/variant-image-slide-element'

/**
 * Get all variants data.
 *
 * @returns {Object|null}
 */
const getAllVariants = () => {
  const variantsDataElement = document.getElementById('variants-data')
  const allVariants = variantsDataElement
    ? JSON.parse(variantsDataElement.innerHTML).variants
    : null

  return returnObjectOrNull(allVariants)
}

/**
 * Get variant from id.
 *
 * @param variantId {number}
 *
 * @returns {Object|null}
 */
const getVariantFromId = (variantId) => {
  const allVariants = getAllVariants()
  const correctVariant = allVariants.find((element) => element.id == variantId)

  return returnObjectOrNull(correctVariant)
}

/**
 * Get selected variants.
 *
 * @returns {number|null}
 */
const getSelectedVariant = () => {
  const variantIdElement = document.querySelector('#variantId')
  const variantId = variantIdElement ? Number(variantIdElement.value) : null
  const variant = getVariantFromId(variantId)

  return returnObjectOrNull(variant)
}

/**
 * Get value from variant Selector.
 * Returns the selected value from a selector element.
 *
 * @param variantElement {HTMLElement}
 * @param optionName {string}
 *
 * @returns {*}
 */
const getValueFromVariantSelector = (variantElement, optionName) => {
  const checkedElement = variantElement.querySelector(
    `input[name="${optionName}"]:checked`
  )

  return returnStringOrNull(checkedElement.value)
}

/**
 * Get correct variant from selected options.
 *
 * @param variantOptions {object}
 *
 * @returns {object|null}
 */
const getCorrectVariantFromOptions = (variantOptions) => {
  const allVariants = getAllVariants()

  if (allVariants != null) {
    // Determine the correct one to get the id
    let selectedOptions = ''

    variantOptions.forEach((variantElement) => {
      const optionName = variantElement.dataset.optionName

      // Join all the selected options into one string.
      selectedOptions =
        selectedOptions +
        ' - ' +
        getValueFromVariantSelector(variantElement, optionName)
    })
    // Splice the string into an array.
    selectedOptions = selectedOptions.slice(3)

    return returnObjectOrNull(
      allVariants.find((element) => element.options === selectedOptions)
    )
  }

  return null
}

/**
 * Is variant available.
 *
 * @param variant {object}
 *
 * @returns {boolean}
 */
const isVariantAvailable = (variant) => {
  return returnBooleanOrNull(variant.available === true)
}

/**
 * Handle set variant in HTML.
 *
 * @param variant {object}
 */
const handleSetVariant = (variant) => {
  const variantId = variant.id

  setVariantId(variantId)
  setVariantImage()
}

/**
 * Set variant image in HTML.
 */
const setVariantImage = () => {
  const variant = getSelectedVariant()

  if (variant) {
    const variantImageParentElement = document.querySelector(
      '.slide.variant-image'
    )
    const variantImageElement = createVariantImageSlideElement(variant)

    if (variantImageElement) {
      // Set new variant image element in the parent element.
      variantImageParentElement.innerHTML = variantImageElement
    }
  }
}

/**
 * Set variant ID in the product form.
 *
 * @param variantId {number}
 */
const setVariantId = (variantId) => {
  const variantIdElement = document.querySelector('#variantId')

  variantIdElement.value = variantId
}

export {
  getAllVariants,
  getVariantFromId,
  getSelectedVariant,
  getCorrectVariantFromOptions,
  isVariantAvailable,
  handleSetVariant,
  setVariantImage,
  getValueFromVariantSelector,
}
